import { tuple } from 'src/replicant/utils/types';

type NoPosition = { scene: ''; location: null };

// prettier-ignore
export const wanderLocations = tuple(
  'tl', 'tc', 'tr',
  'lm', 'c', 'rm',
  'bl', 'bc', 'br',
);

export const livingRoomLocations = tuple(
  ...wanderLocations,
  'mugCenter',
  'aboveLeft',
  'floorFarRight',
  'floorLeft',
  'floorRight',
  'frontCenter',
  'frontLeft',
  'daycare',
);

export type LivingRoomPosition = {
  scene: 'livingRoom' | 'friendsLivingRoom' | 'arena';
  location: (typeof livingRoomLocations)[number];
};
export type DiningRoomPosition = {
  scene: 'diningRoom';
  location:
    | 'mat'
    | 'plate'
    | 'matPlayer'
    | 'matFriend'
    | 'platePlayer'
    | 'plateFriend';
};
type ToiletRoomPosition = {
  scene: 'toiletRoom';
  location: 'toilet' | 'side';
};
type BedroomPosition = {
  scene: 'bedroom';
  location: 'bed';
};
type BathroomPosition = {
  scene: 'bathroom';
  location: 'bath' | 'side';
};
type DebutPosition = {
  scene: 'debut';
  location: 'left' | 'right' | 'shardLeft' | 'shardRight' | 'center';
};

export type Position =
  | LivingRoomPosition
  | DiningRoomPosition
  | ToiletRoomPosition
  | BedroomPosition
  | BathroomPosition
  | DebutPosition
  | NoPosition;
